export enum FeatureFlag {
  FLAG_PNX_CASHIER = "pnx-cashier",
}
